import { createRouter, createWebHistory } from "vue-router";
import store from "@/vuex/store";
import { getToken } from "@/utils/tokenStorage";
import LoginComponent from "@/components/LoginComponent.vue";
import MainImoveis from "@/components/Imoveis/MainImoveis.vue";
import StoreImovel from "@/components/Imoveis/StoreImovel.vue";
import StoreImovelSteped from "@/components/Imoveis/StoreImovelSteped.vue";
import AutoRegisterComponent from "@/components/AutoRegisterComponent.vue";
import UsersComponent from "@/components/admin/UsersComponent.vue";
import ProfileComponent from "@/components/user/ProfileComponent.vue";
import UpdateProfile from "@/components/user/UpdateProfile.vue";
import ActivateUser from "@/components/user/ActivateUser.vue";
import ResetPasswordComponent from "@/components/Auth/ResetPasswordComponent.vue";
import ChangePassword from "@/components/Auth/ChangePassword.vue";
import resetLoader from "@/components/user/resetLoader.vue";
import AdminImoveis from "@/components/admin/AdminImoveis.vue";
import MainDetails from "@/components/home/MainDetails.vue";
import MainRelatorios from "@/components/Reports/MainRelatorios.vue";
import CarouselManager from "@/components/admin/CarouselManager.vue";
import AuditLog from "@/components/admin/AuditLog.vue";
import UserSupport from "@/components/user/UserSupport.vue";
import MySubscription from "@/components/user/MySubscription.vue";
import AdminPlans from "@/components/admin/AdminPlans.vue";
import AdminSubscriptions from "@/components/admin/AdminSubscriptions.vue";
import PlansPublic from "@/components/PlansPublic.vue";
import MainAlojamentos from "@/components/Alojamentos/MainAlojamentos.vue";
import StoreAlojamento from "@/components/Alojamentos/StoreAlojamento.vue";
import MainRentACar from "@/components/RentACar/MainRentACar.vue";
import StoreViatura from "@/components/RentACar/StoreViatura.vue";
import AdminModeration from "@/components/admin/AdminModeration.vue";
import MyCatalogDetails from "@/components/catalog/MyCatalogDetails.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginComponent,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPasswordComponent,
  },
  {
    path: "/reset/:token",
    name: "ResetPasswordWithToken",
    component: resetLoader,
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: { requiresAuth: true },
    props: (route) => ({ reset: route.query.reset }),
  },
  {
    path: "/activate-user/:token",
    name: "ActivateUser",
    component: ActivateUser,
  },
  {
    path: "/auto-register",
    name: "AutoRegister",
    component: AutoRegisterComponent,
  },
  {
    path: "/imoveis",
    name: "imoveis",
    component: MainImoveis,
    meta: { requiresAuth: true },
  },
  {
    path: "/todos-imoveis",
    name: "TodosImoveis",
    component: AdminImoveis,
    meta: { requiresAuth: true },
  },
  {
    path: "/imovel/:slug",
    name: "imovel-details",
    component: MainDetails,
    meta: { requiresAuth: true },
  },
  {
    path: "/imovel/adicionar",
    name: "store-imovel",
    component: StoreImovel,
    meta: { requiresAuth: true },
  },
  {
    path: "/imovel-steped/adicionar",
    name: "store-imovel-steped",
    component: StoreImovelSteped,
    meta: { requiresAuth: true },
  },
  {
    path: "/imovel-steped/editar/:slug",
    name: "edit-imovel-steped",
    component: StoreImovelSteped,
    meta: { requiresAuth: true },
  },
  {
    path: "/alojamentos",
    name: "alojamentos",
    component: MainAlojamentos,
    meta: { requiresAuth: true },
  },
  {
    path: "/alojamentos/adicionar",
    name: "adicionar-alojamento",
    component: StoreAlojamento,
    meta: { requiresAuth: true },
  },
  {
    path: "/alojamentos/editar/:slug",
    name: "editar-alojamento",
    component: StoreAlojamento,
    meta: { requiresAuth: true },
  },
  {
    path: "/alojamentos/:slug",
    name: "detalhes-alojamento",
    component: MyCatalogDetails,
    props: { kind: "accommodation" },
    meta: { requiresAuth: true },
  },
  {
    path: "/rent-a-car",
    name: "rent-a-car",
    component: MainRentACar,
    meta: { requiresAuth: true },
  },
  {
    path: "/rent-a-car/adicionar",
    name: "adicionar-viatura",
    component: StoreViatura,
    meta: { requiresAuth: true },
  },
  {
    path: "/rent-a-car/editar/:slug",
    name: "editar-viatura",
    component: StoreViatura,
    meta: { requiresAuth: true },
  },
  {
    path: "/rent-a-car/:slug",
    name: "detalhes-viatura",
    component: MyCatalogDetails,
    props: { kind: "rental_vehicle" },
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "user-list",
    component: UsersComponent,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/profile",
    name: "user-profile",
    component: ProfileComponent,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/update",
    name: "update-profile",
    component: UpdateProfile,
    meta: { requiresAuth: true },
  },
  {
    path: "/relatorios",
    name: "relatorios",
    component: MainRelatorios,
    meta: { requiresAuth: true },
  },
  {
    path: "/carousel",
    name: "carousel",
    component: CarouselManager,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/auditoria",
    name: "auditoria",
    component: AuditLog,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/support",
    name: "user-support",
    component: UserSupport,
    meta: { requiresAuth: true },
  },
  {
    path: "/subscricao",
    name: "my-subscription",
    component: MySubscription,
    meta: { requiresAuth: true },
  },
  {
    path: "/planos",
    name: "public-plans",
    component: PlansPublic,
  },
  {
    path: "/admin/moderation",
    name: "admin-moderation",
    component: AdminModeration,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admin/plans",
    name: "admin-plans",
    component: AdminPlans,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admin/subscriptions",
    name: "admin-subscriptions",
    component: AdminSubscriptions,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, _from, next) => {
  const isAuthenticated = !!getToken();

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: "Login" });
      return;
    }

    if (to.matched.some((record) => record.meta.requiresAdmin)) {
      if (!store.state.auth.user) {
        try {
          await store.dispatch("auth/getMe");
        } catch {
          next({ name: "Login" });
          return;
        }
      }

      if (store.state.auth.user?.role !== 1) {
        next({ name: "imoveis" });
        return;
      }
    }

    next();
  } else {
    next();
  }
});

export default router;
